import request from './request';

export async function codeGuard(to: any, from: any, next: any) {
 
    let valid = await checkSystemActivation();
    if (valid) {
        console.log('to.path',to.path)
        next();
    } else {
        next('/code-valid?to=' + to.path);
    }
}

let checkSystemActivation = async () => {
    let code = sessionStorage.getItem("freqx_code");
    if (code) {
        let result = await request.post('/api/code/valid', { code });
        return result?.data == true;
    } else {
        return false;
    }

}
